import { render, staticRenderFns } from "./primarydealerfilestable.vue?vue&type=template&id=1ecc7c20&scoped=true&"
import script from "./primarydealerfilestable.vue?vue&type=script&lang=js&"
export * from "./primarydealerfilestable.vue?vue&type=script&lang=js&"
import style0 from "./primarydealerfilestable.vue?vue&type=style&index=0&id=1ecc7c20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc7c20",
  null
  
)

export default component.exports